(function(){
  'use strict';

  var motionOK = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  function esc(str){
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function formatMoney(cents){
    return (cents / 100).toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
  }

  /* Ticker-Inhalt duplizieren für Endlos-Lauf */
  document.querySelectorAll('.ticker-track').forEach(function(track){
    track.innerHTML += track.innerHTML;
  });

  /* Toast */
  var toastTimer = null;
  function showToast(msg){
    var toast = document.getElementById('toast');
    if(!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.classList.remove('show'); }, 2600);
  }

  /* ---------- Mobiles Menü ---------- */
  var menuBtn = document.getElementById('menuBtn');
  var mobileNav = document.getElementById('mobileNav');
  if(menuBtn && mobileNav){
    menuBtn.addEventListener('click', function(){
      var open = !mobileNav.classList.contains('open');
      mobileNav.classList.toggle('open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      menuBtn.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    });
  }

  /* ---------- Scroll: Header-Zustand + Nach-oben-Button ---------- */
  var toTopBtn = document.getElementById('toTop');
  var siteHeader = document.querySelector('.site-header');
  var scrollTick = false;
  window.addEventListener('scroll', function(){
    if(scrollTick) return;
    scrollTick = true;
    requestAnimationFrame(function(){
      if(siteHeader){ siteHeader.classList.toggle('scrolled', window.scrollY > 8); }
      if(toTopBtn){ toTopBtn.classList.toggle('show', window.scrollY > 600); }
      scrollTick = false;
    });
  }, {passive:true});
  if(toTopBtn){
    toTopBtn.addEventListener('click', function(){
      window.scrollTo({top:0, behavior: motionOK ? 'smooth' : 'auto'});
    });
  }

  /* ---------- Scroll-Reveal mit Stagger (respektiert Reduced Motion) ----------
     Im Theme-Editor deaktiviert, damit Sections beim Bearbeiten sofort sichtbar sind */
  if(motionOK && !designMode && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, {threshold:.12, rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.scent-grid, .partner-grid, .values, .review-grid, .faq').forEach(function(grid){
      Array.prototype.forEach.call(grid.children, function(child, i){
        child.classList.add('reveal');
        child.style.transitionDelay = (Math.min(i, 8) * 45) + 'ms';
        io.observe(child);
      });
    });
    document.querySelectorAll('.section-head, .feature, .story, .nl-band, .cta-banner, .dealer-cta, .storybook, .founder, .about-split, .review-note').forEach(function(el){
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  /* ---------- Mengen-Buttons (Produktseite + Warenkorb) ---------- */
  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if(!minus && !plus) return;
    var box = (minus || plus).closest('.qty');
    var input = box && box.querySelector('input[type="number"]');
    if(!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10);
    if(isNaN(min)) min = 1;
    val = minus ? Math.max(min, val - 1) : Math.min(99, val + 1);
    input.value = val;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  /* Warenkorb-Seite: Mengenänderung sendet das Formular automatisch ab */
  var cartForm = document.getElementById('cartForm');
  if(cartForm){
    cartForm.addEventListener('change', function(e){
      if(e.target.matches('input[name="updates[]"]')){ cartForm.submit(); }
    });
  }

  /* ---------- Mini-Warenkorb (Drawer) über die Shopify-Cart-API ---------- */
  var cartDrawer = document.getElementById('cartDrawer');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var drawerBody = document.getElementById('drawerBody');
  var drawerFoot = document.getElementById('drawerFoot');
  var lastFocusEl = null;

  function updateCartCount(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
    });
  }

  function drawerLineHTML(item){
    var imgUrl = (item.featured_image && item.featured_image.url) || item.image || '';
    if(imgUrl){ imgUrl += (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=140'; }
    var variantLine = '';
    if(item.variant_title && item.variant_title !== 'Default Title'){
      variantLine = '<div class="ci-price">' + esc(item.variant_title) + '</div>';
    }
    return '<div class="cart-item">'
      + (imgUrl ? '<img src="' + esc(imgUrl) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '')
      + '<div><b><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></b>'
      + variantLine
      + '<div class="ci-price">' + formatMoney(item.final_price) + ' / Stück</div></div>'
      + '<span class="qty">'
      + '<button type="button" data-drawer-minus="' + esc(item.key) + '" aria-label="Menge verringern">−</button>'
      + '<output>' + item.quantity + '</output>'
      + '<button type="button" data-drawer-plus="' + esc(item.key) + '" aria-label="Menge erhöhen">+</button>'
      + '</span>'
      + '<span class="ci-total">' + formatMoney(item.final_line_price) + '</span>'
      + '<button class="cart-remove" type="button" data-drawer-remove="' + esc(item.key) + '" aria-label="' + esc(item.product_title) + ' entfernen">✕</button>'
      + '</div>';
  }

  function renderDrawer(cart){
    if(!drawerBody) return;
    updateCartCount(cart);
    if(cart.item_count === 0){
      drawerBody.innerHTML = '<div class="drawer-empty">Dein Warenkorb ist noch leer.<br><a class="btn btn-grape btn-sm" href="/collections/all" style="margin-top:18px">Zum Shop ✨</a></div>';
      if(drawerFoot){ drawerFoot.hidden = true; }
    } else {
      drawerBody.innerHTML = cart.items.map(drawerLineHTML).join('');
      if(drawerFoot){
        drawerFoot.hidden = false;
        var subEl = document.getElementById('drawerSubtotal');
        if(subEl){ subEl.textContent = formatMoney(cart.items_subtotal_price); }
      }
    }
  }

  function fetchCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); });
  }

  function openDrawer(){
    if(!cartDrawer) return;
    lastFocusEl = document.activeElement;
    cartDrawer.classList.add('open');
    if(drawerOverlay){ drawerOverlay.classList.add('open'); }
    cartDrawer.setAttribute('aria-hidden','false');
    setTimeout(function(){
      var closeBtn = document.getElementById('drawerClose');
      if(closeBtn){ closeBtn.focus(); }
    }, 80);
  }
  function closeDrawer(){
    if(!cartDrawer || !cartDrawer.classList.contains('open')) return;
    cartDrawer.classList.remove('open');
    if(drawerOverlay){ drawerOverlay.classList.remove('open'); }
    cartDrawer.setAttribute('aria-hidden','true');
    if(lastFocusEl && lastFocusEl.focus){ lastFocusEl.focus(); }
  }

  function changeLine(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity:quantity})
    })
    .then(function(r){
      if(!r.ok) throw new Error('change failed');
      return r.json();
    })
    .then(function(cart){
      renderDrawer(cart);
      /* Auf der Warenkorb-Seite die serverseitige Liste synchron halten */
      if(document.body.getAttribute('data-route') === 'cart'){ window.location.reload(); }
      return cart;
    })
    .catch(function(){ showToast('Hoppla – das hat nicht geklappt. Bitte noch einmal versuchen.'); });
  }

  if(cartDrawer){
    document.querySelectorAll('[data-drawer-open]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        fetchCart().then(renderDrawer);
        openDrawer();
      });
    });
    var drawerClose = document.getElementById('drawerClose');
    if(drawerClose){ drawerClose.addEventListener('click', closeDrawer); }
    if(drawerOverlay){ drawerOverlay.addEventListener('click', closeDrawer); }
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeDrawer(); } });

    document.addEventListener('click', function(e){
      var minus = e.target.closest('[data-drawer-minus]');
      var plus = e.target.closest('[data-drawer-plus]');
      var remove = e.target.closest('[data-drawer-remove]');
      if(minus || plus){
        var key = (minus || plus).getAttribute(minus ? 'data-drawer-minus' : 'data-drawer-plus');
        var out = (minus || plus).closest('.qty').querySelector('output');
        var current = parseInt(out ? out.textContent : '1', 10) || 1;
        changeLine(key, Math.max(0, Math.min(99, minus ? current - 1 : current + 1)));
        return;
      }
      if(remove){ changeLine(remove.getAttribute('data-drawer-remove'), 0); }
    });
  }

  /* AJAX "In den Warenkorb": legt in den Warenkorb und öffnet den Drawer
     (Fallback ohne JS: normales Formular zur Warenkorb-Seite) */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ajax-atc]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if(btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json'},
      body:new FormData(form)
    })
    .then(function(res){
      if(!res.ok) throw new Error('add failed');
      return res.json();
    })
    .then(function(){
      return fetchCart();
    })
    .then(function(cart){
      if(cartDrawer){
        renderDrawer(cart);
        openDrawer();
      } else {
        updateCartCount(cart);
        showToast('✓ Im Warenkorb!');
      }
    })
    .catch(function(){
      form.removeAttribute('data-ajax-atc');
      form.submit();
    })
    .then(function(){ if(btn) btn.disabled = false; });
  });

  /* ---------- Produktseite: Thumbnail-Wechsel ----------
     Alle Bilder werden schon vorgeladen (siehe unten), darum liegt das neue
     Bild beim Klick meist im Cache und ist sofort da. Ist es doch noch nicht
     fertig, wird es erst dekodiert und dann in einem Rutsch getauscht – so
     entsteht nie eine leere Lücke oder ein Ruckeln. */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-stage-src]');
    if(!thumb) return;
    var stageImg = document.querySelector('.product-stage img');
    var url = thumb.getAttribute('data-stage-src');
    document.querySelectorAll('.thumbs button').forEach(function(b){ b.classList.remove('active'); });
    thumb.classList.add('active');
    if(!stageImg || !url) return;
    var apply = function(){
      /* Zwischenzeitlich weitergeklickt? Dann dieses (alte) Bild nicht mehr setzen. */
      if(!thumb.classList.contains('active')) return;
      /* image_tag erzeugt ein srcset – das überstimmt src, sonst bliebe beim
         Wechseln immer das erste Bild stehen. Darum srcset/sizes entfernen. */
      stageImg.removeAttribute('srcset');
      stageImg.removeAttribute('sizes');
      stageImg.src = url;
    };
    var pre = new Image();
    pre.src = url;
    if(pre.decode){ pre.decode().then(apply).catch(apply); }
    else if(pre.complete){ apply(); }
    else { pre.onload = apply; pre.onerror = apply; }
  });

  /* ---------- Produktseite: große Bilder vorladen ----------
     Die Thumbnails zeigen nur eine 128px-Version; das Stage-Bild braucht die
     große. Damit der Wechsel sofort greift, laden wir alle Stage-Größen still
     im Hintergrund vor, sobald der Browser Luft hat. */
  (function(){
    var thumbs = document.querySelectorAll('.thumbs [data-stage-src]');
    if(!thumbs.length) return;
    var warm = function(){
      thumbs.forEach(function(t){
        var u = t.getAttribute('data-stage-src');
        if(u){ var im = new Image(); im.decoding = 'async'; im.src = u; }
      });
    };
    if('requestIdleCallback' in window){ requestIdleCallback(warm, {timeout:1500}); }
    else { setTimeout(warm, 300); }
  })();

  /* ---------- Cookie-Banner ----------
     Bindet Shopifys Customer-Privacy-API an: Die Wahl der Besucher steuert,
     ob Shopify Analyse-/Marketing-Tracking ausführt. Das Shopify-eigene Banner
     sollte im Admin ausgeblendet sein (Einstellungen → Kundendatenschutz). */
  (function(){
    var banner = document.getElementById('cookieBanner');
    if(!banner) return;
    var acceptBtn = document.getElementById('cbAccept');
    var declineBtn = document.getElementById('cbDecline');

    function privacyApi(){
      return (window.Shopify && window.Shopify.customerPrivacy) || null;
    }
    function setConsent(granted){
      var api = privacyApi();
      if(api){
        try{
          api.setTrackingConsent({analytics:granted, marketing:granted, preferences:granted, sale_of_data:granted}, function(){});
        }catch(err){
          try{ api.setTrackingConsent(granted, function(){}); }catch(err2){}
        }
      }
      try{ localStorage.setItem('rubby_cookie_choice', granted ? 'all' : 'essential'); }catch(e){}
      banner.hidden = true;
    }
    if(acceptBtn){ acceptBtn.addEventListener('click', function(){ setConsent(true); }); }
    if(declineBtn){ declineBtn.addEventListener('click', function(){ setConsent(false); }); }

    function maybeShow(){
      if(designMode){ banner.hidden = false; return; }
      var api = privacyApi();
      if(api && typeof api.shouldShowBanner === 'function'){
        /* Shopify weiß, ob für die Region des Besuchers eine Zustimmung nötig ist
           und ob schon eine Entscheidung vorliegt */
        if(api.shouldShowBanner()){ banner.hidden = false; }
        return;
      }
      try{ if(localStorage.getItem('rubby_cookie_choice')){ return; } }catch(e){}
      banner.hidden = false;
    }

    if(privacyApi()){ maybeShow(); }
    else if(window.Shopify && window.Shopify.loadFeatures){
      window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function(){ maybeShow(); });
    } else {
      maybeShow();
    }
  })();

  /* ---------- Radier-Spiel im Hero ----------
     Eine Canvas-Ebene mit Neon-Gekritzel liegt über dem Hero.
     Wer mit Maus oder Finger darüberwischt, radiert es weg – wie ein echter Rubby. */
  (function(){
    var canvas = document.getElementById('heroScribble');
    if(!canvas || !canvas.getContext) return;
    var hero = canvas.closest('.hero');
    var hint = document.getElementById('heroHint');
    if(!hero) return;
    if(!motionOK || designMode){ canvas.remove(); if(hint){ hint.remove(); } return; }

    var ctx = canvas.getContext('2d');
    var finished = false;
    var NEON = ['rgba(180,91,255,.6)','rgba(77,232,255,.55)','rgba(255,160,46,.55)','rgba(255,77,109,.5)'];

    function rand(min, max){ return min + Math.random() * (max - min); }

    /* Rubby-Umriss in 0..1-Koordinaten (c = Farbindex in NEON).
       Wird als verwackelte Kritzel-Linien gezeichnet und laesst sich
       genau wie das alte Zufalls-Gekritzel wegradieren. */
    var MASCOT = [
      {c:3, pts:[[.32,.10],[.68,.10],[.70,.13],[.705,.56],[.68,.59],[.32,.59],[.295,.56],[.30,.13],[.32,.10]]},
      {c:2, pts:[[.305,.26],[.37,.24],[.44,.27],[.51,.24],[.58,.27],[.65,.24],[.70,.26]]},
      {c:1, pts:[[.468,.35],[.46,.37],[.44,.378],[.42,.37],[.412,.35],[.42,.33],[.44,.322],[.46,.33],[.468,.35]]},
      {c:1, pts:[[.588,.35],[.58,.37],[.56,.378],[.54,.37],[.532,.35],[.54,.33],[.56,.322],[.58,.33],[.588,.35]]},
      {c:1, pts:[[.40,.44],[.44,.50],[.50,.52],[.56,.50],[.60,.44]]},
      {c:1, pts:[[.44,.50],[.50,.545],[.56,.50]]},
      {c:3, pts:[[.30,.34],[.24,.30],[.19,.25]]},
      {c:1, pts:[[.19,.25],[.145,.26],[.115,.22],[.13,.17],[.175,.175],[.19,.21],[.19,.25]]},
      {c:3, pts:[[.70,.34],[.76,.30],[.81,.25]]},
      {c:1, pts:[[.81,.25],[.855,.26],[.885,.22],[.87,.17],[.825,.175],[.81,.21],[.81,.25]]},
      {c:3, pts:[[.42,.59],[.415,.74]]},
      {c:2, pts:[[.415,.74],[.33,.76],[.30,.82],[.36,.86],[.46,.85],[.445,.74]]},
      {c:3, pts:[[.58,.59],[.585,.74]]},
      {c:2, pts:[[.585,.74],[.67,.76],[.70,.82],[.64,.86],[.54,.85],[.555,.74]]}
    ];

    function drawScribbles(){
      var w = canvas.width, h = canvas.height;
      if(!w || !h){ return; }
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      /* Mehrere kleine Rubbys, jeder in einer eigenen Neonfarbe – nur im
         Leerraum oben und ueber dem Produktbild, nie ueber Text oder Buttons.
         x/y/s relativ zur Hero-Groesse (s an der Hoehe orientiert). */
      var spots;
      if(w > 860){
        /* Verteilung wie die alten Kritzel-Zonen: zwei kleine oben im
           Leerraum, drei ueber dem Produktbild rechts */
        spots = [
          {x:.12, y:.015, s:.11, c:0},
          {x:.42, y:.015, s:.12, c:1},
          {x:.72, y:.05,  s:.16, c:2},
          {x:.72, y:.31,  s:.21, c:3},
          {x:.77, y:.56,  s:.21, c:0}
        ];
      } else {
        spots = [
          {x:.08, y:.58, s:.18, c:0},
          {x:.56, y:.63, s:.20, c:2},
          {x:.30, y:.80, s:.15, c:1}
        ];
      }
      function jx(v){ return v + rand(-3, 3); }
      spots.forEach(function(spot){
        var box = {x: spot.x * w, y: spot.y * h, s: spot.s * h};
        if(box.x + box.s > w - 6){ box.s = w - 6 - box.x; }
        var col = NEON[spot.c];
        ctx.strokeStyle = col;
        ctx.shadowColor = col;
        ctx.shadowBlur = 9;
        MASCOT.forEach(function(part){
          for(var pass = 0; pass < 2; pass++){
            ctx.lineWidth = rand(2.6, 3.8);
            ctx.beginPath();
            var p0 = part.pts[0];
            ctx.moveTo(jx(box.x + p0[0] * box.s), jx(box.y + p0[1] * box.s));
            for(var i = 1; i < part.pts.length; i++){
              var a = part.pts[i - 1], b = part.pts[i];
              var mx = box.x + (a[0] + b[0]) / 2 * box.s + rand(-4, 4);
              var my = box.y + (a[1] + b[1]) / 2 * box.s + rand(-4, 4);
              ctx.quadraticCurveTo(mx, my, jx(box.x + b[0] * box.s), jx(box.y + b[1] * box.s));
            }
            ctx.stroke();
          }
        });
      });
      ctx.shadowBlur = 0;
    }

    function sizeCanvas(){
      var rect = hero.getBoundingClientRect();
      if(!rect.width){ return; }
      canvas.width = rect.width;
      canvas.height = rect.height;
      if(!finished){
        drawScribbles();
        buildGrid();
      }
    }

    function ensureSized(){
      if(finished){ return; }
      var rect = hero.getBoundingClientRect();
      if(!rect.width){ return; }
      if(Math.abs(rect.width - canvas.width) > 1 || Math.abs(rect.height - canvas.height) > 1){ sizeCanvas(); }
    }

    /* Fortschritt über ein grobes Zell-Raster: einmal nach dem Zeichnen
       abtasten, beim Radieren nur noch Zellen abhaken. So entfällt das
       wiederholte getImageData, das die Canvas ausbremsen würde. */
    var CELL = 20, gridW = 0, gridH = 0, cells = null, totalCells = 0, erasedCells = 0;
    function buildGrid(){
      var w = canvas.width, h = canvas.height;
      gridW = Math.ceil(w / CELL); gridH = Math.ceil(h / CELL);
      cells = new Uint8Array(gridW * gridH);
      totalCells = 0; erasedCells = 0;
      if(!w || !h) return;
      var data = ctx.getImageData(0, 0, w, h).data;
      for(var y = 3; y < h; y += 6){
        for(var x = 3; x < w; x += 6){
          if(data[(y * w + x) * 4 + 3] > 30){
            var idx = ((y / CELL) | 0) * gridW + ((x / CELL) | 0);
            if(!cells[idx]){ cells[idx] = 1; totalCells++; }
          }
        }
      }
    }
    function markErased(x0, y0, x1, y1){
      var steps = Math.max(1, Math.ceil(Math.hypot(x1 - x0, y1 - y0) / CELL));
      for(var s = 0; s <= steps; s++){
        var px = x0 + (x1 - x0) * s / steps;
        var py = y0 + (y1 - y0) * s / steps;
        var cx = (px / CELL) | 0, cy = (py / CELL) | 0;
        for(var dy = -2; dy <= 2; dy++){
          for(var dx = -2; dx <= 2; dx++){
            var gx = cx + dx, gy = cy + dy;
            if(gx < 0 || gy < 0 || gx >= gridW || gy >= gridH) continue;
            var mx = (gx + .5) * CELL - px, my = (gy + .5) * CELL - py;
            if(mx * mx + my * my > 900) continue; /* im Radierer-Radius (~30px)? */
            var idx = gy * gridW + gx;
            if(cells[idx] === 1){ cells[idx] = 2; erasedCells++; }
          }
        }
      }
    }
    function erasedRatio(){
      return totalCells ? erasedCells / totalCells : 1;
    }

    function crumbBurst(){
      var colors = ['#B45BFF', '#4DE8FF', '#FFA02E', '#FF4D6D'];
      for(var i = 0; i < 16; i++){
        var c = colors[i % colors.length];
        var crumb = document.createElement('span');
        crumb.style.cssText =
          'position:absolute;z-index:6;width:' + rand(5, 10) + 'px;height:' + rand(4, 7) + 'px;' +
          'background:' + c + ';box-shadow:0 0 8px ' + c + ';' +
          'border-radius:4px;left:' + rand(15, 85) + '%;top:' + rand(25, 60) + '%;' +
          'transform:rotate(' + rand(0, 180) + 'deg);' +
          'transition:transform .9s ease-in,opacity .9s ease-in;pointer-events:none;';
        hero.appendChild(crumb);
        (function(el){
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){
              el.style.opacity = '0';
              el.style.transform = 'translateY(' + Math.round(rand(260, 420)) + 'px) rotate(' + rand(180, 540) + 'deg)';
            });
          });
          setTimeout(function(){ el.remove(); }, 1000);
        })(crumb);
      }
    }

    var lastPoint = null;
    var queue = [];
    var rafPending = false;

    function finishGame(){
      finished = true;
      hero.classList.remove('erase-active');
      canvas.style.transition = 'opacity .5s';
      canvas.style.opacity = '0';
      if(hint){
        hint.textContent = 'Sauber radiert! ✨';
        hint.classList.add('is-done');
      }
      crumbBurst();
    }

    /* Mausbewegungen sammeln und pro Frame in einem Rutsch radieren –
       mousemove feuert deutlich öfter, als der Bildschirm zeichnen kann */
    function queueErase(clientX, clientY){
      if(finished) return;
      queue.push(clientX, clientY);
      if(!rafPending){
        rafPending = true;
        requestAnimationFrame(flushErase);
      }
    }
    function flushErase(){
      rafPending = false;
      var points = queue;
      queue = [];
      if(finished || !points.length) return;
      if(!totalCells){ ensureSized(); return; }
      var rect = canvas.getBoundingClientRect();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 56;
      ctx.lineCap = 'round';
      ctx.beginPath();
      for(var i = 0; i < points.length; i += 2){
        var x = points[i] - rect.left, y = points[i + 1] - rect.top;
        var fromX = x, fromY = y;
        if(lastPoint && Math.abs(lastPoint.x - x) < 120 && Math.abs(lastPoint.y - y) < 120){
          fromX = lastPoint.x; fromY = lastPoint.y;
        }
        ctx.moveTo(fromX, fromY);
        ctx.lineTo(x + .01, y);
        markErased(fromX, fromY, x, y);
        lastPoint = {x: x, y: y};
      }
      ctx.stroke();
      if(erasedRatio() > 0.65){ finishGame(); }
    }

    hero.classList.add('erase-active');
    sizeCanvas();
    if(!canvas.width){ requestAnimationFrame(sizeCanvas); }
    window.addEventListener('load', ensureSized, {once:true});
    window.addEventListener('resize', function(){
      clearTimeout(sizeCanvas._t);
      sizeCanvas._t = setTimeout(ensureSized, 150);
    });
    hero.addEventListener('mousemove', function(e){ queueErase(e.clientX, e.clientY); });
    hero.addEventListener('touchmove', function(e){
      var t = e.touches[0];
      if(t) queueErase(t.clientX, t.clientY);
    }, {passive:true});
    hero.addEventListener('mouseleave', function(){ lastPoint = null; });
  })();

  /* Zeigergerät mit echtem Hover? Alles Feinmotorische (Aura, Magnet, Kippen)
     bleibt sonst aus – auf dem Touchscreen gäbe es dafür keinen Auslöser. */
  var hoverFine = !!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);

  /* ---------- Duft-Wolke ----------
     Farbige Schwaden steigen vom Radiergummi auf, in den Farben der enthaltenen
     Duftsorten (Cola=braun, Cherry=pink, Apple=grün, Orange=orange, Watermelon=rosa,
     Blueberry=blau, Grape=lila; Multipack=bunt). Dazu tanzen ein paar Aroma-Pünktchen –
     so wird das Markenversprechen (duftende Radiergummis) sichtbar.
     Zwei Stellen brauchen die Wolke: die Karten beim Hovern und das große Bild auf
     der Produktseite. Deshalb steht sie hier als eigener Baustein. */
  var Duft = (function(){
    /* Duftfarben je Sorte (RGB). Reihenfolge im Produkttitel = Reihenfolge der Schwaden. */
    var SCENTS = [
      ['cola', '181,121,63'], ['cherry', '255,77,143'], ['kirsch', '255,77,143'],
      ['apple', '60,203,90'], ['apfel', '60,203,90'], ['orange', '255,160,46'],
      ['watermelon', '255,111,165'], ['wassermelone', '255,111,165'],
      ['blueberry', '77,124,255'], ['blaubeere', '77,124,255'],
      ['grape', '180,91,255'], ['traube', '180,91,255']
    ];
    var ALL_SCENTS = ['181,121,63', '255,77,143', '60,203,90', '255,160,46', '77,124,255', '180,91,255'];

    function toRgb(c){
      c = (c || '').trim();
      if(c.charAt(0) === '#'){ var n = parseInt(c.slice(1), 16); return (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255); }
      var m = c.match(/[\d.]+/g);
      return m ? (m[0] + ',' + m[1] + ',' + m[2]) : '180,91,255';
    }

    /* Palette aus dem Produkttitel; fällt auf die Sortenfarbe des Elements zurück */
    function paletteFor(text, el){
      var t = String(text || '').toLowerCase();
      if(/multi\s*pack|alle\s*6|alle\s*sechs/.test(t)) return ALL_SCENTS.slice();
      var found = [];
      for(var i = 0; i < SCENTS.length; i++){
        if(t.indexOf(SCENTS[i][0]) > -1 && found.indexOf(SCENTS[i][1]) < 0){ found.push(SCENTS[i][1]); }
      }
      if(found.length) return found;
      if(t.indexOf('mix pack') > -1) return ['255,160,46', '180,91,255', '181,121,63'];
      return [toRgb((el ? getComputedStyle(el).getPropertyValue('--card-color') : '') || '#B45BFF')];
    }

    /* Legt ein Canvas über host und lässt die Schwaden steigen.
       Rückgabe: {stop}. opt.blend='source-over' für helle Untergründe –
       additives Mischen würde auf dem weißen Produktfoto verschwinden. */
    function start(host, pal, opt){
      if(!host) return null;
      opt = opt || {};
      var blend = opt.blend || 'lighter';
      var alpha = opt.alpha || 1;
      if(getComputedStyle(host).position === 'static'){ host.style.position = 'relative'; }
      var rect = host.getBoundingClientRect();
      var W = rect.width, H = rect.height;
      if(!W || !H) return null;

      var cv = document.createElement('canvas');
      cv.setAttribute('aria-hidden', 'true');
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:3;opacity:0;transition:opacity .3s';
      host.appendChild(cv);
      var ctx = cv.getContext('2d');
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = W * dpr; cv.height = H * dpr; ctx.scale(dpr, dpr);

      var N = Math.max(3, pal.length), wisps = [];
      for(var wn = 0; wn < N; wn++){
        wisps.push({cx:.30 + .44 * (N === 1 ? .5 : wn / (N - 1)), amp:6 + (wn % 3) * 2, freq:.035 + (wn % 3) * .01, ph:wn * 2.0, sp:.9 + (wn % 3) * .35, w:6 + (wn % 3), col:pal[wn % pal.length]});
      }
      var parts = [];
      for(var pn = 0; pn < 8; pn++){ parts.push({x:.32 + Math.random()*.4, y:Math.random(), vy:.10 + Math.random()*.10, drift:(Math.random()-.5)*.06, r:1.5 + Math.random()*2, col:pal[pn % pal.length]}); }

      var state = {stopped:false, raf:0};
      var t0 = performance.now(), last = t0;
      function frame(now){
        if(state.stopped) return;
        var dt = (now - t0) / 1000, d = Math.min(.05, (now - last) / 1000); last = now;
        ctx.clearRect(0, 0, W, H);
        ctx.globalCompositeOperation = blend;
        ctx.lineCap = 'round';
        for(var wi = 0; wi < wisps.length; wi++){
          var w = wisps[wi]; ctx.shadowColor = 'rgba(' + w.col + ',.95)'; ctx.shadowBlur = 16;
          var top = H * .05, bot = H * .92, prev = null;
          for(var y = bot; y > top; y -= 5){
            var p = (bot - y) / (bot - top);
            var ph = w.ph - dt * w.sp;
            var spread = 1 + p * 2.2;
            var x = W * w.cx + Math.sin(y * w.freq + ph) * w.amp * spread + Math.sin(y * w.freq * 2.3 + ph) * w.amp * .3 * spread;
            var a = Math.sin(p * Math.PI) * .5 * alpha;
            var lw = w.w * (1 - p) * (1 - p) + .6;
            if(prev){ ctx.strokeStyle = 'rgba(' + w.col + ',' + a.toFixed(3) + ')'; ctx.lineWidth = lw; ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(x, y); ctx.stroke(); }
            prev = {x:x, y:y};
          }
        }
        for(var pi = 0; pi < parts.length; pi++){
          var pt = parts[pi];
          pt.y -= pt.vy * d; pt.x += pt.drift * d * .4;
          if(pt.y < .02){ pt.y = .95; pt.x = .32 + Math.random() * .4; }
          var pa = Math.sin((1 - pt.y) * Math.PI) * .7 * alpha;
          ctx.shadowColor = 'rgba(' + pt.col + ',.9)'; ctx.shadowBlur = 10;
          ctx.fillStyle = 'rgba(' + pt.col + ',' + pa.toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(pt.x * W, pt.y * H, pt.r, 0, 6.2832); ctx.fill();
        }
        state.raf = requestAnimationFrame(frame);
      }
      state.raf = requestAnimationFrame(frame);
      requestAnimationFrame(function(){ cv.style.opacity = '1'; });

      state.stop = function(){
        if(state.stopped) return;
        state.stopped = true;
        cancelAnimationFrame(state.raf);
        cv.style.opacity = '0';
        setTimeout(function(){ if(cv.parentNode){ cv.parentNode.removeChild(cv); } }, 340);
      };
      return state;
    }

    return {palette:paletteFor, rgb:toRgb, start:start};
  })();

  /* ---------- Produktseite: Bild-Zoom wie bei Amazon ----------
     Beim Drüberfahren legt sich ein Auswahl-Rahmen (Lupe) auf das Bild, und
     rechts daneben erscheint ein separates Fenster, das genau diesen Ausschnitt
     groß und scharf zeigt – gespeist aus einer höher aufgelösten Bildversion. */
  (function(){
    var stage = document.querySelector('.product-stage');
    if(!stage || !motionOK || designMode || !hoverFine) return;
    var img = stage.querySelector('img');
    if(!img) return;

    var ZOOM = 2.6;
    var lens = null, result = null, active = false, raf = null, last = null;

    /* Shopify-CDN-URL auf eine größere Breite heben, damit der Ausschnitt auch
       bei starker Vergrößerung scharf bleibt. */
    function hiRes(src){
      if(!src) return src;
      try{
        var u = new URL(src, location.href);
        u.searchParams.set('width', '1600');
        return u.href;
      }catch(e){ return src; }
    }

    function build(){
      if(lens) return;
      lens = document.createElement('div');
      lens.className = 'rr-zoom-lens';
      stage.appendChild(lens);
      result = document.createElement('div');
      result.className = 'rr-zoom-result';
      document.body.appendChild(result);
    }

    function show(){
      build();
      result.style.backgroundImage = 'url("' + hiRes(img.currentSrc || img.src) + '")';
      lens.style.display = 'block';
      result.style.display = 'block';
      active = true;
    }
    function hide(){
      active = false; last = null;
      if(lens) lens.style.display = 'none';
      if(result) result.style.display = 'none';
    }

    function place(){
      raf = null;
      if(!active || !last) return;
      var ir = img.getBoundingClientRect();
      var sr = stage.getBoundingClientRect();
      var rr = result.getBoundingClientRect();
      var lensW = rr.width / ZOOM, lensH = rr.height / ZOOM;
      lens.style.width  = lensW + 'px';
      lens.style.height = lensH + 'px';

      /* Zeiger im Bild – so geklemmt, dass die Lupe nie über den Bildrand ragt. */
      var lx = last.x - ir.left - lensW / 2;
      var ly = last.y - ir.top  - lensH / 2;
      lx = Math.max(0, Math.min(lx, ir.width  - lensW));
      ly = Math.max(0, Math.min(ly, ir.height - lensH));

      lens.style.left = (ir.left - sr.left + lx) + 'px';
      lens.style.top  = (ir.top  - sr.top  + ly) + 'px';

      result.style.backgroundSize = (ir.width * ZOOM) + 'px ' + (ir.height * ZOOM) + 'px';
      result.style.backgroundPosition = '-' + (lx * ZOOM) + 'px -' + (ly * ZOOM) + 'px';

      /* Fenster rechts neben die Bühne; ist dort kein Platz, nach links klappen. */
      var gap = 18;
      var left = sr.right + gap;
      if(left + rr.width > window.innerWidth - 10){
        left = sr.left - gap - rr.width;
        if(left < 10) left = Math.max(10, window.innerWidth - rr.width - 10);
      }
      var top = Math.min(sr.top, window.innerHeight - rr.height - 10);
      if(top < 10) top = 10;
      result.style.left = left + 'px';
      result.style.top  = top + 'px';
    }

    stage.addEventListener('pointerenter', function(e){
      if(e.pointerType && e.pointerType !== 'mouse') return;
      show();
    });
    stage.addEventListener('pointermove', function(e){
      if(!active) return;
      last = {x:e.clientX, y:e.clientY};
      if(!raf) raf = requestAnimationFrame(place);
    }, {passive:true});
    stage.addEventListener('pointerleave', hide);
    window.addEventListener('scroll', function(){ if(active) hide(); }, {passive:true});
  })();

  /* ---------- Trauben und Cola um das Wort "Duft." ----------
     Das Versprechen der Startseite steht in der Überschrift – hier sieht man
     auch, wonach: Kurz nachdem die Neonwörter gezündet haben, legt sich eine
     warme Aura um das Wort, und nach links treiben skizzierte Trauben hinaus,
     nach rechts Cola-Flaschen – die beiden Sorten aus dem Bild daneben, in
     derselben Kritzel-Handschrift wie die Rubbys im Hero.
     Alles bleibt in der Zeile des Wortes, damit die Zeile darüber frei bleibt.
     Nach ein paar Sekunden ist Ruhe; wer mit dem Zeiger über das Wort fährt,
     löst es erneut aus. */
  (function(){
    if(!motionOK || designMode) return;
    var hero = document.querySelector('.hero');
    var word = hero && hero.querySelector('h1 .neon-duft');
    if(!hero || !word) return;

    var box = document.createElement('div');
    box.className = 'hero-plume';
    box.setAttribute('aria-hidden', 'true');
    hero.appendChild(box);

    /* Umrisse in 0..1-Koordinaten, wie das Rubby-Gekritzel im Radier-Spiel */
    function circlePts(cx, cy, r, n){
      var pts = [];
      for(var i = 0; i <= n; i++){
        var a = i / n * 6.2832;
        pts.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
      }
      return pts;
    }
    var GRAPE = [
      [[.50,.17],[.53,.09],[.51,.02]],                        /* Stiel */
      [[.53,.07],[.66,.02],[.75,.07],[.62,.12],[.53,.07]],    /* Blatt */
      circlePts(.50,.29,.115,9),
      circlePts(.34,.43,.115,9),
      circlePts(.66,.43,.115,9),
      circlePts(.50,.55,.115,9),
      circlePts(.36,.68,.11,9),
      circlePts(.64,.68,.11,9),
      circlePts(.50,.81,.105,9)
    ];
    var COLA = [
      [[.42,.03],[.58,.03],[.58,.11],[.42,.11],[.42,.03]],    /* Deckel */
      [[.44,.11],[.44,.22],[.31,.34],[.29,.55],[.30,.86],[.38,.95],[.62,.95],[.70,.86],[.71,.55],[.69,.34],[.56,.22],[.56,.11]],
      [[.29,.52],[.71,.52]],                                  /* Etikett */
      [[.30,.70],[.70,.70]],
      [[.34,.62],[.44,.58],[.56,.66],[.66,.61]]               /* Schwung im Etikett */
    ];

    var PAD = 190;          /* Wunschplatz links und rechts */
    var SLOTS = 3;          /* gleichzeitig treibende Skizzen je Seite */
    var CYCLE = 3.4;        /* Sekunden von der Wortkante bis nach außen */
    var cv = null, ctx = null, raf = 0, timer = null, t0 = 0, W = 0, H = 0;
    var drifters = [], cxWord = 0, halfWord = 0, baseSize = 46;

    function place(){
      var hr = hero.getBoundingClientRect(), wr = word.getBoundingClientRect();
      if(!wr.width) return false;
      /* Das Feld bleibt im Hero – auf schmalen Bildschirmen wird es einfach
         enger, statt am Rand abgeschnitten zu werden. */
      var left = Math.max(4, wr.left - hr.left - PAD);
      var right = Math.min(hr.width - 4, wr.right - hr.left + PAD);
      box.style.left = left + 'px';
      box.style.width = (right - left) + 'px';
      box.style.top = (wr.top - hr.top) + 'px';
      box.style.height = wr.height + 'px';
      cxWord = (wr.left - hr.left) - left + wr.width / 2;
      halfWord = wr.width / 2;
      baseSize = Math.max(28, Math.min(54, wr.height * .42));
      return true;
    }

    /* Einmal pro Runde verwackeln, nicht pro Bild – sonst würde die Linie kochen */
    function shake(parts){
      return parts.map(function(pts){
        return pts.map(function(p){
          return [p[0] + (Math.random() - .5) * .04, p[1] + (Math.random() - .5) * .04];
        });
      });
    }
    function reseed(d){
      d.paths = shake(d.side < 0 ? GRAPE : COLA);
      d.size = baseSize * (.85 + Math.random() * .3);
      d.rot = (Math.random() - .5) * .5;
      d.spin = (Math.random() - .5) * .6;
      d.lift = 14 + Math.random() * 16;
    }

    function draw(d, x, y, alpha, p){
      var col = d.side < 0 ? '180,91,255' : '216,152,86';
      var s = d.size;
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(d.rot + d.spin * p);
      ctx.strokeStyle = 'rgba(' + col + ',' + alpha.toFixed(3) + ')';
      ctx.shadowColor = 'rgba(' + col + ',.85)';
      ctx.shadowBlur = 12;
      ctx.lineWidth = 2.4;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      for(var i = 0; i < d.paths.length; i++){
        var pts = d.paths[i];
        ctx.beginPath();
        ctx.moveTo((pts[0][0] - .5) * s, (pts[0][1] - .5) * s);
        for(var j = 1; j < pts.length; j++){
          var a = pts[j - 1], b = pts[j];
          ctx.quadraticCurveTo(((a[0] + b[0]) / 2 - .5) * s, ((a[1] + b[1]) / 2 - .5) * s,
                               (b[0] - .5) * s, (b[1] - .5) * s);
        }
        ctx.stroke();
      }
      ctx.restore();
    }

    function frame(now){
      var t = (now - t0) / 1000;
      var cx = cxWord, cy = H * 0.54;
      var r0 = halfWord + 26;               /* startet an der Wortkante */
      /* Weiter als bis kurz vor den Feldrand darf nichts treiben */
      var r1 = Math.min(r0 + 120, Math.min(cx, W - cx) - baseSize * .62);
      ctx.clearRect(0, 0, W, H);
      if(r1 <= r0){ raf = requestAnimationFrame(frame); return; }
      ctx.globalCompositeOperation = 'lighter';
      for(var i = 0; i < drifters.length; i++){
        var d = drifters[i];
        var p = ((t / CYCLE) + d.phase) % 1;
        if(p < d.lastP){ reseed(d); }        /* neue Runde, neue Skizze */
        d.lastP = p;
        var dist = r0 + (r1 - r0) * p;
        var x = cx + d.side * dist;
        var y = cy - d.lift * p + Math.sin(p * 5.5 + d.phase * 6) * 4;
        draw(d, x, y, Math.sin(p * Math.PI) * .95, p);
      }
      raf = requestAnimationFrame(frame);
    }

    function stop(){
      clearTimeout(timer); timer = null;
      cancelAnimationFrame(raf); raf = 0;
      word.classList.remove('is-scenting');
      if(cv){
        var old = cv; cv = null; ctx = null;
        old.style.opacity = '0';
        setTimeout(function(){ if(old.parentNode){ old.parentNode.removeChild(old); } }, 500);
      }
    }

    function play(){
      if(cv || !place()) return;
      var rect = box.getBoundingClientRect();
      W = rect.width; H = rect.height;
      if(!W || !H) return;
      cv = document.createElement('canvas');
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;opacity:0;transition:opacity .5s';
      box.appendChild(cv);
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = W * dpr; cv.height = H * dpr;
      ctx = cv.getContext('2d');
      ctx.scale(dpr, dpr);

      drifters = [];
      for(var s = 0; s < SLOTS; s++){
        [-1, 1].forEach(function(side){
          /* Rechts eine halbe Lücke versetzt, damit nicht beide Seiten im Takt laufen */
          var d = {side:side, phase:s / SLOTS + (side > 0 ? .5 / SLOTS : 0), lastP:2};
          reseed(d);
          drifters.push(d);
        });
      }

      t0 = performance.now();
      raf = requestAnimationFrame(frame);
      word.classList.add('is-scenting');
      requestAnimationFrame(function(){ if(cv){ cv.style.opacity = '1'; } });
      timer = setTimeout(stop, 11000);
    }

    /* Erst wenn die Überschrift fertig gezündet hat */
    setTimeout(play, 2000);
    word.addEventListener('pointerenter', play);
    window.addEventListener('resize', stop, {passive:true});
  })();

  /* ---------- Duftaura am Zeiger ----------
     Ein weicher Schimmer läuft dem Mauszeiger nach, wird über Klickbarem
     größer und nimmt die Farbe der Sorte an, über der er gerade steht. */
  (function(){
    if(!motionOK || designMode || !hoverFine) return;
    var aura = document.createElement('div');
    aura.className = 'rr-aura';
    aura.setAttribute('aria-hidden', 'true');
    document.body.appendChild(aura);

    var x = 0, y = 0, cx = 0, cy = 0, scale = 1, target = 1, raf = null, shown = false, host = null;

    function loop(){
      cx += (x - cx) * .18; cy += (y - cy) * .18; scale += (target - scale) * .14;
      aura.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
      if(Math.abs(x - cx) > .4 || Math.abs(y - cy) > .4 || Math.abs(target - scale) > .004){
        raf = requestAnimationFrame(loop);
      } else { raf = null; }
    }
    function kick(){ if(!raf){ raf = requestAnimationFrame(loop); } }

    document.addEventListener('pointermove', function(e){
      if(e.pointerType && e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      if(!shown){ shown = true; cx = x; cy = y; aura.classList.add('show'); }
      kick();
    }, {passive:true});

    document.addEventListener('pointerover', function(e){
      var t = e.target;
      if(!t || t.nodeType !== 1 || !t.closest) return;
      target = t.closest('a,button,[role="button"],input,select,textarea,summary,.scent-card') ? 2.1 : 1;
      /* Farbe nur neu auslesen, wenn eine andere Sorten-Umgebung erreicht ist */
      var next = t.closest('[style*="--card-color"]');
      if(next !== host){
        host = next;
        aura.style.setProperty('--aura-rgb', Duft.rgb(next ? getComputedStyle(next).getPropertyValue('--card-color') : '#B45BFF'));
      }
      kick();
    }, {passive:true});

    document.addEventListener('mouseleave', function(){ shown = false; aura.classList.remove('show'); });
    document.addEventListener('mouseenter', function(){ if(!shown){ shown = true; aura.classList.add('show'); } });
  })();

  /* ---------- Magnetische Haupt-Buttons ----------
     Nur die großen CTAs, damit der Effekt eine Ausnahme bleibt und nicht
     die ganze Seite zappelt. */
  (function(){
    if(!motionOK || designMode || !hoverFine) return;
    document.querySelectorAll('.btn-grape:not(.btn-sm),.btn-orange:not(.btn-sm)').forEach(function(btn){
      btn.classList.add('rr-magnet');
      btn.addEventListener('pointermove', function(e){
        var r = btn.getBoundingClientRect();
        btn.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * .22).toFixed(1) + 'px');
        btn.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * .3).toFixed(1) + 'px');
      }, {passive:true});
      btn.addEventListener('pointerleave', function(){
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  })();

  /* ---------- Das Produkt fliegt in den Warenkorb ----------
     Beim Klick auf "In den Warenkorb" löst sich eine Kopie des Produktbilds,
     fliegt im Bogen zum Warenkorb-Knopf und die Zahl dort hüpft. */
  (function(){
    if(!motionOK) return;
    if(!document.body.animate) return;
    document.addEventListener('submit', function(e){
      var form = e.target.closest && e.target.closest('form[data-ajax-atc]');
      if(!form) return;
      var card = form.closest('.scent-card');
      var img = card ? card.querySelector('img') : document.querySelector('.product-stage img');
      var target = document.querySelector('.cart-btn[data-drawer-open]');
      if(!img || !target) return;
      var r = img.getBoundingClientRect();
      var t = target.getBoundingClientRect();
      if(!r.width || !t.width) return;

      var fly = document.createElement('img');
      fly.className = 'rr-fly';
      fly.src = img.currentSrc || img.src;
      fly.alt = '';
      fly.setAttribute('aria-hidden', 'true');
      var w = Math.min(r.width, 190), h = w * (r.height / r.width);
      fly.style.left = (r.left + (r.width - w) / 2) + 'px';
      fly.style.top = (r.top + (r.height - h) / 2) + 'px';
      fly.style.width = w + 'px';
      fly.style.height = h + 'px';
      document.body.appendChild(fly);

      var dx = t.left + t.width / 2 - (r.left + r.width / 2);
      var dy = t.top + t.height / 2 - (r.top + r.height / 2);
      var anim = fly.animate([
        {transform:'translate(0,0) scale(1) rotate(0deg)', opacity:1},
        {transform:'translate(' + (dx * .5).toFixed(0) + 'px,' + (dy * .5 - 80).toFixed(0) + 'px) scale(.5) rotate(-9deg)', opacity:.95, offset:.6},
        {transform:'translate(' + dx.toFixed(0) + 'px,' + dy.toFixed(0) + 'px) scale(.1) rotate(12deg)', opacity:0}
      ], {duration:620, easing:'cubic-bezier(.45,0,.35,1)'});
      var landed = false;
      function land(){
        if(landed) return;
        landed = true;
        fly.remove();
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.classList.remove('rr-pop');
          void el.offsetWidth;
          el.classList.add('rr-pop');
        });
      }
      anim.onfinish = anim.oncancel = land;
      /* Ein Tabwechsel friert die Animation ein – dieser Nachzügler
         räumt die Kopie dann trotzdem weg. */
      setTimeout(land, 4000);
    }, true);
  })();

  /* ---------- Radier-Krümel beim In-den-Warenkorb-Legen ----------
     Kleiner Freude-Moment, der das Radier-Motiv der Marke aufgreift:
     bunte Krümel stieben aus dem Button und fallen weg. */
  (function(){
    if(!motionOK) return;
    var COLORS = ['#B45BFF', '#4DE8FF', '#FFA02E', '#FF4D6D'];
    document.addEventListener('submit', function(e){
      var form = e.target.closest && e.target.closest('form[data-ajax-atc]');
      if(!form) return;
      var btn = form.querySelector('[type="submit"]');
      if(!btn) return;
      var r = btn.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      for(var i = 0; i < 12; i++){
        (function(i){
          var col = COLORS[i % COLORS.length];
          var el = document.createElement('span');
          el.style.cssText = 'position:fixed;left:' + cx + 'px;top:' + cy + 'px;z-index:1200;width:' + (5 + Math.round(Math.random()*5)) + 'px;height:' + (4 + Math.round(Math.random()*4)) + 'px;background:' + col + ';box-shadow:0 0 8px ' + col + ';border-radius:3px;pointer-events:none;transition:transform .8s cubic-bezier(.2,.7,.3,1),opacity .8s ease-in;transform:translate(-50%,-50%) rotate(' + Math.round(Math.random()*180) + 'deg)';
          document.body.appendChild(el);
          var ang = Math.random() * 6.2832, dist = 30 + Math.random() * 60;
          var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist * .5 + 60 + Math.random() * 45;
          requestAnimationFrame(function(){ requestAnimationFrame(function(){
            el.style.opacity = '0';
            el.style.transform = 'translate(calc(-50% + ' + dx.toFixed(0) + 'px), calc(-50% + ' + dy.toFixed(0) + 'px)) rotate(' + Math.round(Math.random()*540) + 'deg)';
          }); });
          setTimeout(function(){ el.remove(); }, 850);
        })(i);
      }
    }, true);
  })();
})();
